module.exports = __webpack_public_path__ + "static/media/values.cbe287a2.png";